import { useCallback, useState } from "react"
import _isEqual from "lodash/isEqual"

import { storageService } from "@/services"

export type UseSessionStorage<T = any> = {
  key: string
  initialValue: T
}

const useSessionStorage = <T extends any = any>(
  props: UseSessionStorage<T>,
): [T, (value: T) => void] => {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const { key, initialValue } = props

  const [storedValue, setStoredValue] = useState<T>(
    () => storageService.getSessionItem<T>(key) || initialValue,
  )

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to SessionStorage.
  const setValue = useCallback(
    (value: T) => {
      if (!_isEqual(storedValue, value)) {
        setStoredValue(value)
        storageService.saveSessionItem(key, value)
      }
    },
    [key, storedValue],
  )

  return [storedValue, setValue]
}

export default useSessionStorage
